import React from 'react';
import './App.css';
import MarsRover from './MarsRoverPhotos';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <MarsRover />
      </header>
    </div>
  );
}

export default App;
